import CartUpsell, { CartUpsellConfig } from "../interfaces/cart/CartUpsell";
import CartUpsellLayoutEnum from "../enums/CartUpsellLayoutEnum";
import upsellThemes, { isMultiProductUpsellTheme } from "../components/checkout/upsells/pre/layouts/fullscreen/upsellThemes";

const images = require.context("../images", false, /\.(png|svg|jpe?g|gif)$/u);

const preloadImages = () => {
    const paths = images.keys();
    if (!paths?.length) {
        return;
    }

    const dynamicImports = paths.map((file) => {
        // Get just the filename with extension.
        const pattern = /[^/]+$/u;
        const matches = pattern.exec(file);
        return matches ? matches[0] : null;
    }).map((imageName) => import(`../images/${imageName}`)); // Use import so we get the correct path and hash.

    Promise.all(dynamicImports)
        .then((modules) => {
            modules.forEach((module) => {
                const img = new Image();
                img.src = module.default;
            });
        })
        .catch((error) => {
            console.error("Failed to preload images.", error);
        });
};

export default preloadImages;

export const preloadUpsellImages = (cartUpsellConfig: CartUpsellConfig) => {
    if (cartUpsellConfig.layout !== CartUpsellLayoutEnum.FULL_SCREEN) {
        return;
    }

    const files = cartUpsellConfig.upsells.reduce((acc: string[], upsell: CartUpsell) => {
        const theme = upsellThemes[upsell.upsell_id];
        if (!theme) {
            return acc;
        }
        // Since we are already importing images in upsellThemes.ts, they will already have the correct path and hash.
        acc.push(theme.bgImage);
        if (isMultiProductUpsellTheme(theme)) {
            acc.push(theme.authorityImageOverride);
            acc.push(theme.authorityImageOverrideMobile);
        }

        return acc;
    }, []);

    // Filter undefined, dedupe then load image
    Array.from(new Set(files.filter((file) => Boolean(file)))).forEach((file) => {
        const img = new Image();
        img.src = file;
    });
};
